<template>
  <div>
    <el-card class="mb-16">
      <div class="columns">
        <!-- 儀器選擇 -->
        <div class="column is-narrow">
          <label class="label">{{ $t('remark.instrumentSelector') }}</label>
          <el-tooltip
            :content="$t('remark.info.instrumentSelector')"
            class="ml-8"
            placement="top"
          >
            <el-cascader
              v-model="form.instrument_id"
              size="large"
              :key="propsKey"
              :props="props"
              :options="projectOptions"
              :collapse-tags="true"
              :show-all-levels="false"
              :placeholder="$t('chart.instrument.pick')"
              :loading="loadingInstrument"
              @change="onInstrumentChange"
              style="width:280px"
            />
          </el-tooltip>
        </div>

        <!-- 時間選擇 -->
        <div class="column is-narrow">
          <label class="label">{{ $t('remark.timeSelector') }}</label>
          <el-tooltip
            :content="$t('remark.info.timeSelector')"
            class="ml-8"
            placement="top"
          >
            <el-date-picker
              v-model="form.range"
              type="datetimerange"
              :start-placeholder="$t('date.start')"
              :end-placeholder="$t('date.end')"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00']"
              format="yyyy/MM/dd HH:mm"
              value-format="timestamp"
              style="width:340px"
              @change="onRangeChange"
            />
          </el-tooltip>
        </div>
      </div>
    </el-card>

    <enhanced-table
      v-if="showTable"
      :table-data="remarkList"
      :col-configs="colConfigs"
      :is-loading="isLoading"
      :title="tableTitle"
    >
      <div slot="header" class="table-header flex-row justify-between" v-if="mode==='instrument'">
        <el-button @click="showCreateForm" type="primary">
          {{ $t('remark.editBtn.add') }}
        </el-button>
      </div>
      <template v-slot:actions="{ colConfig }" v-if="mode==='instrument'">
        <el-table-column v-bind="colConfig">
          <template v-slot="{ row }">
            <el-button @click="showEditForm(row._id)" size="mini" type="warning">
              {{ $t('remark.editBtn.edit') }}
            </el-button>
            <el-button @click="deleteInstrumentRemark(row._id)" size="mini" type="danger">
              {{ $t('remark.editBtn.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </template>
    </enhanced-table>
    <remark-form
      v-if="showCreateRemark"
      :editing-remark="editingRemark"
      :instrument="form.instrument"
      :form-type="formType"
      @close="handleFormClose"
      @success="getInstrumentRemark"
    />
  </div>
</template>

<script>
import moment from 'moment';
import MomentTimeZone from 'moment-timezone';
import RemarkForm from '@/components/remark/CreateForm.vue';
import EnhancedTable from '@/components/common/EnhancedTable';
import { convertRemarkType } from '@/lib/base/remark';
MomentTimeZone();

export default {
  components: {
    RemarkForm,
    EnhancedTable,
  },
  props: {
    useUrl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      showCreateRemark: false,
      loadingInstrument: false,
      form: {
        instrument: '',
        instrument_id: null,
        range: null,          // [startTs, endTs]
      },
      editingRemark: {},
      formType: 'create',
      instrumentList: [],
      remarkList: [],

      projectOptions: [],
      propsKey: 1000,
      props: {
        label: 'label',
        value: 'value',
        children: 'children',
      },

      datePickerOptions: {
        disabledDate(date) { return date > new Date(); },
      },
    };
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    selectedInstrument() {
      console.log('selectedInstrument');
      if (this.instrumentList.length > 0 && this.form.instrument) {
        let ins = this.instrumentList.find(ele => ele._id === this.form.instrument);
        console.log(ins);
        return ins;
      } else {
        return {};
      }
    },

    mode() {
      if (this.form.instrument) return 'instrument';
      if (Array.isArray(this.form.range) && this.form.range.length === 2) return 'time';
      return 'none';
    },

    tableTitle() {
      if (this.mode === 'instrument') return this.selectedInstrument?.latestVersion?.name || this.$t('remark.title');
      if (this.mode === 'time') {
        const [s, e] = this.form.range || [];
        return `${this.$t('remark.title')}（${this.$moment(s).format('YYYY-MM-DD HH:mm')} ~ ${this.$moment(e).format('YYYY-MM-DD HH:mm')}）`;
      }
      return this.$t('remark.title');
    },

    showTable() { return this.mode !== 'none'; },

    colConfigs() {
      const vm = this;

      if(this.mode == 'instrument'){
        return [
          {
            label: '類型',
            prop: 'type',
            formatter(column, row, cellValue) {
              return vm.$t(convertRemarkType(cellValue));
            },
          },
          {
            label: '內容',
            prop: 'content',
          },
          {
            label: '開始時間',
            prop: 'start_date',
            formatter(column, row, cellValue) {
              return vm.$moment(cellValue).format('YYYY-MM-DD HH:mm');
            },
          },
          {
            label: '結束時間',
            prop: 'end_date',
            formatter(column, row, cellValue) {
              return vm.$moment(cellValue).format('YYYY-MM-DD HH:mm');
            },
          },
          { slot: 'actions', width: '150px' },
        ];
      }
      
      return [
        {
          label: '儀器名稱',
          prop: 'instrumentName',
        },
        {
          label: '類型',
          prop: 'type',
          formatter(column, row, cellValue) {
            return vm.$t(convertRemarkType(cellValue));
          },
        },
        {
          label: '內容',
          prop: 'content',
        },
        {
          label: '開始時間',
          prop: 'start_date',
          formatter(column, row, cellValue) {
            return vm.$moment(cellValue).format('YYYY-MM-DD HH:mm');
          },
        },
        {
          label: '結束時間',
          prop: 'end_date',
          formatter(column, row, cellValue) {
            return vm.$moment(cellValue).format('YYYY-MM-DD HH:mm');
          },
        },
        { slot: 'actions', width: '150px' },
      ];
    },
  },
  mounted() {
    this.initCascaderSelector();
  },
  methods: {
    getInstrumentRemark() {
      this.isLoading = true;
      this.$axios({
        category: 'project',
        method: 'post',
        apiName: `${this.selectedProject._id}/instrument/remark?type=all`,
        data: {
          instrument: this.form.instrument,
        },
      })
        .then(res => {
          this.remarkList = res.data;
        })
        .catch(this.$notifyError)
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getCascaderInstrumentList() {
      await this.getInstrumentList();

      this.form.instrument = this.form.instrument_id[2];
      this.getInstrumentRemark();
    },

    async onInstrumentChange() {
      // 若被程式清空（null/空陣列）就直接 return，避免不必要查詢
      if (!this.form.instrument_id || this.form.instrument_id.length < 3) return;

      // 清空時間
      this.form.range = null;

      // 讀儀器列表（含 latestVersion）以供 selectedInstrument 顯示
      await this.getInstrumentList();

      // 取 cascader 的第三層值（instrumentId）
      this.form.instrument = this.form.instrument_id[2];

      // 依儀器查它的全部備註
      this.getInstrumentRemark();
    },

    onRangeChange(val) {
      if (!val || val.length < 2) return;

      // 清空儀器選擇
      this.form.instrument = '';
      this.form.instrument_id = null;

      // 查時間區間的所有備註
      this.getRemarkByTimeRange();
    },
    getRemarkByTimeRange() {
      if (!this.form.range || this.form.range.length < 2) return;
      const [start_date, end_date] = this.form.range;

      this.isLoading = true;
      this.$axios({
        category: 'project',
        method: 'post',
        apiName: `${this.selectedProject._id}/instrument/remark?type=date`,
        data: { start_date, end_date },   // 後端接受 timestamp 或 ISO string 都可
      })
        .then(res => { 
          this.remarkList = res.data || []; 
          console.log(res.data);
        })
        .catch(this.$notifyError)
        .finally(() => { this.isLoading = false; });
    },

    async deleteInstrumentRemark(remarkId) {
      const response = await this.$confirmDelete('是否删除此備註？', '提示', {
        confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning',
      });
      if (response !== 'confirm') return;

      this.isLoading = true;
      this.$axios({
        category: 'project',
        method: 'delete',
        apiName: `${this.selectedProject._id}/instrument/${this.form.instrument}/remark/${remarkId}`,
      })
        .then(() => { this.$notifySuccess('刪除成功'); this.getInstrumentRemark(); })
        .catch(this.$notifyError)
        .finally(() => { this.isLoading = false; });
    },

    handleFormClose() { 
      this.showCreateRemark = false; 
      this.editingRemark = {}; 
    },
    showEditForm(remarkId) { 
      this.formType = 'edit'; 
      this.editingRemark = this.remarkList.find(e => e._id === remarkId) || {}; 
      this.showCreateRemark = true; 
    },
    showCreateForm() {
      this.formType = 'create';
      this.showCreateRemark = true;
    },

    /* 初始化 cascader 選單 */
    initCascaderSelector() {
      return this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${this.selectedProject._id}/area-station-instrument`,
      })
        .then(res => {
          this.projectOptions = res.data.area.map(area => ({
            label: area.name,
            disabled: area.station.length === 0,
            children: area.station.map(st => ({
              label: st.name,
              disabled: st.instrument.length === 0,
              children: st.instrument
                .map(ins => ({ label: ins.latestVersion.name, value: ins._id }))
                .filter(Boolean),
            })).filter(s => s.children?.length),
          })).filter(a => a.children?.length);
        })
        .catch(err => this.$notifyError(this.$t('chart.error.loading'), err?.response?.data?.message));
    },

    getInstrumentList() {
      this.loadingInstrument = true;
      this.instrumentList = [];
      this.form.instrument = '';
      return new Promise(resolve => {
        this.$store.dispatch('data/getProjectInstrumentListWithLatestVersion', {
          projectId: this.selectedProject._id, isUpdate: true,
        })
          .then(res => { this.instrumentList = res; })
          .catch(this.$notifyError)
          .finally(() => { this.loadingInstrument = false; resolve(); });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.table-header
  width 100%
  margin-right 16px
</style>
